import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Persisted view-mode preference for the Invoices list (CLAUDE.md §2.3),
 * mirroring the CRM list stores. Search/direction/status filters live in
 * URL-bound page state and stay out of the store — those are server-driven
 * query params, not durable user prefs.
 */
export type InvoicesViewMode = 'table' | 'list' | 'cards' | 'grouped';

export const INVOICES_VIEW_MODES: InvoicesViewMode[] = ['table', 'list', 'cards', 'grouped'];

interface InvoicesUiState {
  view: InvoicesViewMode;
  setView: (view: InvoicesViewMode) => void;
  /** Current DRF `OrderingFilter` value (e.g. `-issue_date`). Session-only. */
  ordering: string | undefined;
  setOrdering: (ordering: string | undefined) => void;
}

export const useInvoicesUi = create<InvoicesUiState>()(
  persist(
    (set) => ({
      view: 'table',
      setView: (view) => set({ view }),
      ordering: undefined,
      setOrdering: (ordering) => set({ ordering }),
    }),
    {
      name: 'finance.invoices:ui',
      // Only the view mode is durable — ordering stays ephemeral so refreshes
      // return to a clean default.
      partialize: (state) => ({ view: state.view }),
    },
  ),
);
